<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light" v-if="canViewDriverAll">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchDriver" class="form-inline my-2 my-lg-0">
                    <input
                            class="form-control mr-sm-2"
                            type="search"
                            v-model="search.driver_name"
                            placeholder="คนขับ"
                            aria-label="Search"/>
                    <button @click="searchDriver"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ชื่อ-นามสกุล</th>
                    <th scope="col">ยอดผ่อนรถทั้งหมดที่ต้องจ่าย</th>
                    <th scope="col">ยอดเงินผ่อนรถสะสม</th>
                    <th scope="col">ยอดเงินผ่อนคงเหลือ</th>
                    <th scope="col">ยอดผ่อนหลังคาทั้งหมด</th>
                    <th scope="col">ยอดเงินผ่อนหลังคาสะสม</th>
                    <th scope="col">ยอดเงินผ่อนคงเหลือ</th>
                    <th scope="col">ดูข้อมูล</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in driverList">
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.car_fee_total | currency }}</td>
                    <td>{{data.amount_car_fee ? data.amount_car_fee : 0| currency }}</td>
                    <td>{{data.car_fee_total && data.amount_car_fee? parseFloat(data.car_fee_total) - parseFloat(data.amount_car_fee) : 0 | currency }}</td>
                    <td>{{data.car_roof_total ? parseFloat(data.car_roof_total) : 0 | currency}}</td>
                    <td>{{data.amount_car_roof ? data.amount_car_roof : 0| currency }}</td>
                    <td>{{data.car_roof_total && data.amount_car_roof? parseFloat(data.car_roof_total) - parseFloat(data.amount_car_roof) : 0 | currency }}</td>
                    <td>
                        <button @click="showData(data.id)"
                                class="btn btn-default next">
                            ดูข้อมูล
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="driverList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getDriverPage">
            </vue-pagination>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"/>
        </b-modal>
        <br/>
        <!--<pre class="alert alert-primary">{{ dataPaginate }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import VuePagination from "../../Pagination";
    import {
        canViewDriver,
        canViewDriverAll,
    } from "../../../util/Permissions";
    import Loading from "../../Utility/Loading";

    export default {
        components: {Loading, VuePagination},
        name: "car-fee-list",
        data(){
            return {
                search:{
                    page : 1,
                    driver_name:"",
                },
                msg : 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่',
                status_loading : 1,
                event_submit : false
            }
        },
        created(){
            this.$store.dispatch("Driver/getDriverBigCar",this.search);
            this.$store.dispatch("TransportType/setTransportTypes");
        },
        computed:{
            canViewDriver,
            canViewDriverAll,
            ...mapState({
                driverList:state=>{
                    return state.Driver.driverList;
                },
                transportType:state=>{
                    return [
                        {
                            value: "",
                            text: "ค้นหาประเภทรถ"
                        },
                        ...state.TransportType.transportTypeList.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
                dataPaginate:state=>{
                    return state.Driver.dataPaginate
                },
            })
        },
        methods:{
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            showData(id){
                this.showLoadingModal();
                this.$store.dispatch('Driver/getDriverById',id)
                    .then(()=>{
                        this.$store.dispatch("DriverDetails/getCarFeeDriver",{
                            driver_id : id,
                            page : 1,
                        }).then(()=>{
                            this.$router.push({
                                name : "car-fee-information"
                            });
                        }).catch(()=>{
                            this.msg = 'ดาวโหลดข้อมูล กรุณารอสักครู่';
                            this.status_loading = 3;
                        })
                    }).catch(()=>{
                    this.msg = 'ดาวโหลดข้อมูล กรุณารอสักครู่';
                    this.status_loading = 3;
                });
            },
            searchDriver(){
                this.search.page = this.dataPaginate.current_page;
                this.event_submit = true;
                this.$store.dispatch('Driver/getDriverBigCar',this.search);
            },
            getDriverPage(){
                this.search.page = this.dataPaginate.current_page;
                this.$store.dispatch("Driver/getDriverBigCar",this.search);
            }
        }
    }
</script>

<style scoped>

</style>
